import React, { FC } from 'react'
import { Table } from '@wmgtech/legato'

import { ConcertArtist } from 'shared/__gql-types'
import { ArtistAvatar } from 'components'
import TourLabel from 'modules/Feed/components/TourLabel/TourLabel'
import { formatConcertDate } from 'shared/utils/formatDate'

import { UpcomingToursProps } from './UpcomingTours.props'
import styles from './UpcomingTours.module.scss'

const UpcomingTours: FC<UpcomingToursProps> = ({ upcomingTours, title, isSpace }) => (
  <div className={styles.container}>
    <h3 className={styles.title}>Upcoming Tour Dates in {title}</h3>
    <Table
      data={upcomingTours}
      condensed
      rowKey={(record: ConcertArtist) => `${record?.artist?.id}${record?.concert?.id}`}
      pagination={false}
      columns={[
        {
          key: 'artist',
          title: 'Artist',
          dataIndex: 'artist',
          sortable: false,
          render: (_, tour) => (
            <div className={styles.artist}>
              <ArtistAvatar
                className="project-list-item__avatar"
                spotifyId={tour?.artist?.spotify_id || ''}
                facebookId={tour?.artist?.facebook_id || ''}
                size="m"
              />
              <div className={styles.name}>{tour?.artist?.name}</div>
            </div>
          )
        },
        ...(isSpace
          ? [
            {
              key: 'zone',
              dataIndex: 'zone',
              title: 'Zone',
              sortable: false,
              render: (_: string, tour: ConcertArtist) => <TourLabel tour={tour} />
            }
          ]
          : []),
        {
          key: 'date',
          dataIndex: 'date',
          title: 'Date',
          sortable: false,
          render: (_, tour) => <div>{tour?.concert?.date ? 
            formatConcertDate(tour.concert.date) : null}</div>
        },
        {
          key: 'city',
          dataIndex: 'city',
          title: 'City, Venue',
          sortable: false,
          render: (_, tour) => (
            <div>
              {tour.concert?.cityName}, {tour.concert?.venue}
            </div>
          )
        }
      ]}
    />
  </div>
)

export default UpcomingTours
